import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=93007bd2&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93007bd2')) {
      api.createRecord('93007bd2', component.options)
    } else {
      api.reload('93007bd2', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=93007bd2&", function () {
      api.rerender('93007bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vendor/vue-js-modal/components/Modal.vue"
export default component.exports